import { lazy } from "react";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import {
  AUTOMOBILE_POLICY_FORM_CANCELLATION_REINSTATEMENT,
  AUTOMOBILE_POLICY_FORM_CERTIFICATE_INSURANCE,
  AUTOMOBILE_POLICY_FORM_OPCF48,
  AUTOMOBILE_POLICY_FORM_OPCF49,
  AUTOMOBILE_POLICY_FORM_SEF13D,
  AUTOMOBILE_POLICY_FORM_SEF13H,
  AUTOMOBILE_POLICY_FORM_SEF16,
  AUTOMOBILE_POLICY_FORM_SEF17,
  AUTOMOBILE_POLICY_FORM_SEF19,
  AUTOMOBILE_POLICY_FORM_SEF28A,
  AUTOMOBILE_POLICY_FORM_SEF40,
  COMM_AUTOMOBILE_POLICY_FORM_COMMERCIAL_VEHICLE_SUPPLEMENT,
  COMM_AUTOMOBILE_POLICY_FORM_GARAGE_SUPPLEMENTARY,
} from "./CommAutomobile.constants";

const CommAutoOPCF48 = Loadable(
  lazy(() =>
    import("./CommAutoOPCF_48/CommAutoOPCF_48").then(({ CommAutoOPCF_48 }) => ({
      default: CommAutoOPCF_48,
    }))
  )
);
const CommAutoOPCF49 = Loadable(
  lazy(() =>
    import("./CommAutoOPCF_49/CommAutoOPCF_49").then(({ CommAutoOPCF_49 }) => ({
      default: CommAutoOPCF_49,
    }))
  )
);
const CommAutoSEF16 = Loadable(
  lazy(() =>
    import("./CommAutoSEF_16/CommAutoSEF_16").then(({ CommAutoSEF_16 }) => ({
      default: CommAutoSEF_16,
    }))
  )
);
const CommAutoSEF17 = Loadable(
  lazy(() =>
    import("./CommAutoSEF_17/CommAutoSEF_17").then(({ CommAutoSEF_17 }) => ({
      default: CommAutoSEF_17,
    }))
  )
);
const CommAutoSEF19 = Loadable(
  lazy(() =>
    import("./CommAutoSEF_19/CommAutoSEF_19").then(({ CommAutoSEF_19 }) => ({
      default: CommAutoSEF_19,
    }))
  )
);
const CommAutoSEF13D = Loadable(
  lazy(() =>
    import("./CommAutoSEF_13D/CommAutoSEF_13D").then(({ CommAutoSEF_13D }) => ({
      default: CommAutoSEF_13D,
    }))
  )
);
const CommAutoSEF13H = Loadable(
  lazy(() =>
    import("./CommAutoSEF_13H/CommAutoSEF_13H").then(({ CommAutoSEF_13H }) => ({
      default: CommAutoSEF_13H,
    }))
  )
);
const CommAutoSEF40 = Loadable(
  lazy(() =>
    import("./CommAutoSEF_40/CommAutoSEF_40").then(({ CommAutoSEF_40 }) => ({
      default: CommAutoSEF_40,
    }))
  )
);
const CommAutoSEF28A = Loadable(
  lazy(() =>
    import("./CommAutoSEF_28A/CommAutoSEF_28A").then(({ CommAutoSEF_28A }) => ({
      default: CommAutoSEF_28A,
    }))
  )
);
const AutomobileCertificateInsurance = Loadable(
  lazy(() =>
    import(
      "./CommAutomobileCertificateInsurance/CommAutomobileCertificateInsurance"
    ).then(({ CommAutomobileCertificateInsurance }) => ({
      default: CommAutomobileCertificateInsurance,
    }))
  )
);
const CommAutoCancellation = Loadable(
  lazy(() =>
    import("./CommAutoCancellation/CommAutoCancellation").then(
      ({ CommAutoCancellation }) => ({
        default: CommAutoCancellation,
      })
    )
  )
);

const CommAutoPolicyIntactAuthorization = Loadable(
  lazy(() =>
    import(
      "./CommAutoPolicyForms/CommAutoPolicyIntactAuthorization/CommAutoPolicyIntactAuthorization"
    ).then(({ CommAutomobilePolicyIntactAuthorization }) => ({
      default: CommAutomobilePolicyIntactAuthorization,
    }))
  )
);

const CommAutomobileLossNotice = Loadable(
  lazy(() =>
    import("./CommAutoPolicyForms/CommAutoLossNotice/CommAutoLossNotice").then(
      ({ CommAutomobileLossNotice }) => ({
        default: CommAutomobileLossNotice,
      })
    )
  )
);

const CommAutoCreateARSWrapper = Loadable(
  lazy(() =>
    import("./CommAutoApplication/CommAutoCreateARSWrapper").then(
      ({ CommAutoCreateARSWrapper }) => ({
        default: CommAutoCreateARSWrapper,
      })
    )
  )
);

const CommAutoCSV = Loadable(
  lazy(() =>
    import("./CommAutoCSV/CommAutoCSV").then(({ CommAutomobileCSV }) => ({
      default: CommAutomobileCSV,
    }))
  )
);

export const CommAutoSupplementaryForm = Loadable(
  lazy(() =>
    import("./CommAutoSupplementaryForm/CommAutoSupplementaryTab").then(
      ({ CommAutoSupplementaryForm }) => ({
        default: CommAutoSupplementaryForm,
      })
    )
  )
);

export const CommAutomobilePolicyFormsRoutes = [
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF48}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoOPCF48 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF48}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoOPCF48 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF48}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoOPCF48 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF49}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoOPCF49 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF49}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoOPCF49 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF49}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoOPCF49 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF16}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF16 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF16}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF16 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF16}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF16 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF17}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF17 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF17}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF17 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF17}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF17 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF19}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF19 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF19}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF19 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF19}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF19 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF13D}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF13D />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF13D}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF13D />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF13D}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF13D isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF13H}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF13H />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF13H}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF13H />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF13H}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF13H isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF40}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF40 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF40}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF40 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF40}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF40 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF28A}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF28A />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF28A}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF28A />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF28A}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSEF28A isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_CERTIFICATE_INSURANCE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <AutomobileCertificateInsurance />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_CERTIFICATE_INSURANCE}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <AutomobileCertificateInsurance />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_CERTIFICATE_INSURANCE}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <AutomobileCertificateInsurance isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_CANCELLATION_REINSTATEMENT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCancellation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_CANCELLATION_REINSTATEMENT}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCancellation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_CANCELLATION_REINSTATEMENT}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCancellation isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/intact-authorization`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoPolicyIntactAuthorization />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/intact-authorization/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoPolicyIntactAuthorization />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/intact-authorization/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoPolicyIntactAuthorization isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/loss-notice`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileLossNotice />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/loss-notice/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileLossNotice />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/loss-notice/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileLossNotice isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId/quote-ars",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <CommAutoCreateARSWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTOMOBILE_POLICY_FORM_GARAGE_SUPPLEMENTARY}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSupplementaryForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTOMOBILE_POLICY_FORM_GARAGE_SUPPLEMENTARY}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <CommAutoSupplementaryForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTOMOBILE_POLICY_FORM_GARAGE_SUPPLEMENTARY}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <CommAutoSupplementaryForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTOMOBILE_POLICY_FORM_COMMERCIAL_VEHICLE_SUPPLEMENT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCSV />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTOMOBILE_POLICY_FORM_COMMERCIAL_VEHICLE_SUPPLEMENT}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCSV />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTOMOBILE_POLICY_FORM_COMMERCIAL_VEHICLE_SUPPLEMENT}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCSV isDuplicate />
      </AuthorizedRoute>
    ),
  },
];
